import React from "react";
import {
  Form,
  Input,
  Space,
  Button,
  Popconfirm,
  Divider,
  Upload,
  Card,
} from "antd";
import { InboxOutlined, CloseOutlined, SaveOutlined } from "@ant-design/icons";
import ThaiDatePicker from "../../../../hook/ThaiDatePicker";
import { FORM_LAYOUT } from "../constants";

const { TextArea } = Input;
const { Dragger } = Upload;

const FormWithdrawAccusation = ({
  form,
  onFinish,
  onFinishFailed,
  onChangeDate,
  uploadProps,
  handleCancel,
}) => {
  return (
    <Card style={{ borderRadius: 8 }}>
      <Form
        {...FORM_LAYOUT}
        form={form}
        layout="horizontal"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Divider orientation="left">🔚 ถอนฟ้อง</Divider>

        <Form.Item
          label="ถอนวันที่"
          name="withdrawCaseDate"
          rules={[{ required: true, message: "กรุณาเลือกวันที่" }]}
        >
          <ThaiDatePicker
            onChange={onChangeDate}
            placeholder="กรุณาเลือกวันที่"
            size="large"
            style={{ width: "100%" }}
          />
        </Form.Item>

        <Form.Item
          label="อัพโหลดไฟล์เอกสาร"
          name="file"
          rules={[{ required: true, message: "กรุณาอัปโหลดไฟล์เอกสาร !" }]}
        >
          <Dragger
            {...uploadProps}
            style={{
              padding: "20px",
              background: "#fafafa",
              borderRadius: 8,
            }}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined style={{ color: "#1890ff", fontSize: 48 }} />
            </p>
            <p className="ant-upload-text" style={{ fontSize: 16 }}>
              กรุณาคลิกหรือลากเพื่อเลือกไฟล์
            </p>
          </Dragger>
        </Form.Item>

        <Form.Item
          label="หมายเหตุ"
          name="memo"
          rules={[{ required: true, message: "กรุณากรอกหมายเหตุ !" }]}
        >
          <TextArea
            rows={5}
            placeholder="กรอกเหตุผลในการถอนฟ้อง"
            showCount
            maxLength={500}
          />
        </Form.Item>

        <Form.Item wrapperCol={{ span: 24 }}>
          <div style={{ textAlign: "center", marginTop: 32 }}>
            <Space size="large">
              <Button
                size="large"
                onClick={handleCancel}
                icon={<CloseOutlined />}
                style={{ minWidth: 120 }}
              >
                ปิด
              </Button>
              <Popconfirm
                placement="topLeft"
                title="อัพเดทสถานะ"
                description="กรุณาตรวจสอบข้อมูลให้เรียบร้อย !"
                onConfirm={() => form.submit()}
                okText="ยืนยัน"
                cancelText="ปิด"
                okButtonProps={{ size: "large" }}
                cancelButtonProps={{ size: "large" }}
              >
                <Button
                  type="primary"
                  size="large"
                  icon={<SaveOutlined />}
                  style={{ minWidth: 120 }}
                >
                  บันทึก
                </Button>
              </Popconfirm>
            </Space>
          </div>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default FormWithdrawAccusation;
